/**
 * Styles aligned with Figma Add Forms modal (2257-134097). The shared Commons Modal already
 * provides the 580px width, white 24px-radius box, 80px header (24px padding, bottom border,
 * bold 24 navy heading, X) and 80px right-aligned footer; these only adapt its body and footer.
 */

const PRIMARY_BLUE = 'var(--blue-main, #0F48B8)';
const DARK_GREY = 'var(--grey-110, #333333)';

/** MUI v5 `sx` overrides passed to the Commons Modal `styles` prop. */
export const ADD_FORMS_MODAL_FRAME_STYLES = {
  // Rows carry their own 16px/24px inset, so the body only keeps the 8px vertical padding.
  modalBodyStyles: {
    padding: '8px 0',
  },
  // Commons renders Continue before Cancel with a 40px Stack spacing; the design is Cancel then Add, 12px apart.
  modalFooterStyles: {
    '& > div:first-of-type': {
      flexDirection: 'row-reverse',
      gap: '12px',
      '& > button': {
        margin: 0,
      },
    },
  },
};

const addFormsModalStyles = () => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '60vh',
    overflowY: 'auto',
  },
  listItem: {
    minHeight: 56,
    padding: '12px 24px 8px 16px',
    gap: 16,
  },
  formName: {
    flex: 1,
    minWidth: 0,
    fontFamily: 'Inter, sans-serif',
    fontWeight: 700,
    fontSize: 16,
    color: DARK_GREY,
    overflowWrap: 'anywhere',
  },
  // Bare 24px control so the row stays at the 56px design height.
  checkbox: {
    padding: 0,
    color: PRIMARY_BLUE,
    '& .MuiSvgIcon-root': {
      fontSize: 24,
    },
    '&.Mui-checked': {
      color: PRIMARY_BLUE,
    },
  },
  status: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 56,
    padding: '12px 24px 8px 16px',
  },
});

export default addFormsModalStyles;
